import styled, { css } from "styled-components";
import {
	colorWhite,
	colorMain,
	selectListShadow,
	selectBorderColor,
	colorBlack,
	colorLightGrey2
} from '../../../utils/css/colors';
import { inputBorderRadius, selectHeaderWidth, selectHeaderHeight, selectedItemsHeight, selectBorderRadius } from '../../../utils/css/sizes';
import { body14 } from '../../../utils/css/typography';
import { ScrollBarStyles } from '../../../utils/css/scrollBar';
import { bodyFont, lightFont } from "../../../utils/css/fonts";
import { mobile } from "../../../utils/css/media";

export const SelectContainer = styled.div`
	position: relative;
	margin-inline-end: 12px;
`;

export const SelectHeaderContainer = styled.div<{ isActive: boolean,isOpen: boolean; keyName?: string }>`
	font-size: 18px;
	background: ${({ isActive }) => isActive ? "#f3f3f3a6" : colorWhite };
	border-radius: ${selectBorderRadius}px;
	min-width: ${({ keyName }) => (keyName === 'city' ? '139px' : `102px`)};
	height: ${selectHeaderHeight}rem;
	padding: 9px 20px;
	border: 1px solid ${selectBorderColor};
	outline: none;
	cursor: pointer;
	border-color: ${({ isOpen, isActive }) => (isOpen || isActive) && colorBlack};
	transition: all 0.1s ease-in;
	display: flex;
	justify-content: space-between;
	position: relative;
	opacity: 1;
	font-family: lightFont;
`;

export const SelectHeaderInput = styled.input<{ isActive: boolean }>`
	background: ${({ isActive }) => isActive ? "#f3f3f3a6" : colorWhite };
	max-width: calc(${selectHeaderWidth}rem);
	cursor: pointer;
	border: none;
	outline: none;
	font-family: ${bodyFont};
	font-size: 18px;
	::-webkit-input-placeholder {
		${body14};
		font-size: 18px;
		color: ${colorMain};
	}
`;
export const SelectHeaderIcon = styled.img<{ listOpen: boolean; rotate: number }>`
	transform: rotate(${({ listOpen, rotate }) => (listOpen && !!rotate ? 180 : 0)}deg);
	transition: 0.3s;
	height: 7px;
    width: 13px;
`;

export const IconWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`

export const TitleSpan = styled.span`
	display: flex;
	align-items: center;
	color: ${colorBlack};
	padding-inline-end: 1rem;
	font-weight: 300;
	font-family: ${bodyFont};
	font-size: 18px;
	white-space: nowrap;
`;

export const SelectHeaderIconContainer = styled.div`
  display: flex;
`;

export const ListContainer = styled.div<{ relativeStyle: boolean }>`
  width: 100%;
  min-width: max-content;
  background: ${colorWhite};
  border-radius: ${inputBorderRadius}px;
  box-shadow: ${selectListShadow};
  position: absolute;
  top: ${selectHeaderHeight}rem;
  margin-top: 5px;
  overflow: auto;
  z-index: 3;
  max-height: 250px;
  ${ScrollBarStyles}
  @media (max-width: 1100px) {
	max-height: 140px;
  }

  @media (max-width: 1450px)  {
	${
		props => props.relativeStyle &&
		`
			position: relative;
			top: unset;
		`
	}
  }
`;

export const Item = styled.div<{ selected?: boolean; selectedList?: boolean }>`
	border-radius: 6px;
	height: 24px;
	padding: 2px 6px;
	transition: all 0.1s ease-in;
	margin: 6px 4px;
	display: flex;
	gap: 10px;
	font-family: ${bodyFont};
  	font-size: 16px;
	color: #646363;
	&:hover {
		cursor: pointer;
	}
`;

export const ListDiv = styled.div`
	width: 93%;
	height: 1px;
	background: ${colorLightGrey2};
	margin: 0 auto;
`;

export const SelectedItemsContainer = styled.div`
  margin-bottom: 5px;
`;

export const SelectedItemsSummaryContainer = styled.div<{
  selectedItemsLength: number;
}>`
  background: ${colorWhite};
  width: max-content;
  box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem 2rem;
  position: relative;
  margin-top: 0.8rem;
  opacity: ${({ selectedItemsLength }) => (selectedItemsLength > 0 ? 1 : 0)};

  &:hover {
    & > div {
      display: ${({ selectedItemsLength }) =>
        selectedItemsLength > 1 && "block"};
      z-index: 1;
      width: inherit;
    }
  }

  & > span {
    cursor: ${({ selectedItemsLength }) =>
      selectedItemsLength > 1 && "pointer"};
  }
`;

export const SelectedItemsSummaryTitle = styled.span<{
  direction?: "rtl" | "ltr";
}>`
  margin: ${({ direction }) =>
    direction === "rtl" ? "0 0 0  2rem" : "0 2rem 0 0"};
`;

export const ClearIcon = styled.img`
  cursor: pointer;
`;

export const SelectedItemsList = styled.div`
  width: ${selectedItemsHeight}px;
  height: max-content;
  background: white;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  display: none;
  position: absolute;
  top: 2.4rem;
  left: 0;
  right: 0;
  margin-top: 1.3rem;
  padding: 1.2rem 4px;
  transition: display 0.5s ease-in;

  & > div {
    &:not(:last-child) {
      margin-bottom: 0.9rem;
    }
  }
`;
